import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import { setSelectedCompositiontemplateId,setCompositiontemplateList } from '../../../../store/slice/PharmaSlice';
import { setProductEditproductModal } from '../../../../store/slice/PharmaSlice';
import SelectCompositionTemplate from 'components/compositiontemplate/components/SelectCompositionTemplate';
import {getAPI as getCompositionTemplateObj} from "components/compositiontemplate/CompositiontemplateAPI";
import SelectProductOrderType from 'story/SelectProductOrderType';


export default function EditproductActionImpl() {
    const dispatch = useDispatch()
    const { compositiontemplateList } = useSelector((state) => state.pharmaslice);
    const { compositiontemplateObj } = useSelector((state) => state.pharmaslice.compositiontemplateDashboard)
    const [filter, setFilter] = useState(''); // State to manage filter input
    const [selectedRow, setSelectedRow] = useState(null); // State to track selected row
    const [hoveredRow, setHoveredRow] = useState(null); // State to track hovered row
    const { selectedCTid } = useSelector((state) => state.appslice);

    const close = () => {
        if (selectedCTid!== undefined && selectedCTid !== '') {
                // If selectedCTid is set, then load the composition template object
                getCompositionTemplateObj(selectedCTid, (data) => {        
                    const arr = Array.isArray(data) ? data : [data]; // Ensure data is an array as it will be set as Array
                    dispatch(setCompositiontemplateList(arr));
                    dispatch(setSelectedCompositiontemplateId(arr[0].id));
                });
        }
        dispatch(setProductEditproductModal(false));
    }
    return (
        <>
            <SelectProductOrderType sectionHeight={{lg:'65vh',  md:'57vh', sm:'57vh', xs:'57vh',  }}/>
            <Grid item xs={12}>
                <Grid container justifyContent="flex-end" alignItems="center" sx={{ width: '100%', paddingTop: 2 }}>
                    {/* <Button variant="contained" onClick={() => clearSelection()}>Clear Selection</Button>&nbsp;&nbsp;&nbsp; */}
                    <Button variant="contained" onClick={() => close()}>Continue</Button>
                </Grid>
            </Grid>
        </>
    );
}